<i18n>
zh-TW:
  step1: 點擊右上角的…
  step2: 選擇在瀏覽器中打開

en:
  step1: Click on the "…" in the top-right corner
  step2: Open in Browser

ja:
  step1: 右上の「…」をクリック
  step2: 「ブラウザで開く」をクリック

ko:
  step1: 오른쪽 상단 클릭….
  step2: 웹 브라우저에서 열기

</i18n>

<script>
// 透传不了vuex中的lang
// import { mapState } from 'vuex'

export default {
  data() {
    return {
      visible: false
    }
  },
  methods: {
    close() {
      this.visible = false
    },
    setLocale() {
      if (process.client) {
        // vuex传递不了state，粗暴解决
        const [params = ''] = location.href.split('?')
        params.split('&').forEach((item) => {
          const [k = '', v = ''] = item.split('=')
          if ((k === 'language' || k === 'lang') && v) {
            this.$i18n.locale = v
          }
        })
      }
    }
  },
  render() {
    // console.log("this.$i18n.locale=", this.$i18n.locale)
    return (
      <div class="guide-browser" v-show={this.visible} onClick={this.close}>
        <div class="arrow"></div>
        <div class="cont">
          <ol>
            <li> {this.$t('step1')}</li>
            <li> {this.$t('step2')}</li>
          </ol>
        </div>
      </div>
    )
  }
}
</script>
<style lang="scss" scoped>
.guide-browser {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 99;
  background: rgba(0, 0, 0, 0.8);
}
.arrow {
  position: absolute;
  top: 40px;
  right: 40px;
  z-index: 100;
  width: 48px;
  height: 48px;
  background: no-repeat center
    url(https://cdn.poizon.com/node-common/JUU2JTkyJUE0JUU1JTlCJTlFJUU3JUFFJUFEJUU1JUE0JUI0QDN4JTIwKDIpMTU4NzA5Mzg2MTU2Nw==.png);
  background-size: contain;
}
.cont {
  position: absolute;
  top: 190px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  color: rgba(255, 255, 255, 0.9);
  font-size: 36px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  ol {
    counter-reset: sectioncounter;
  }
  li {
    margin-bottom: 80px;
    &:before {
      content: counter(sectioncounter) '.';
      counter-increment: sectioncounter;
    }
  }
}
</style>
